import React, { useState, useEffect } from 'react';
import './System.css';
import { systemAPI } from '../utils/api';

function System({ currentUser, onNavigate }) {
  const [apps, setApps] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSystemData();
  }, []);

  const loadSystemData = async () => {
    try {
      setLoading(true);
      
      // Load apps and stats using API utility
      const [appsData, statsData] = await Promise.all([
        systemAPI.getApps().catch(() => ({ apps: [] })),
        systemAPI.getStats().catch(() => ({ stats: null })),
      ]);
      
      setApps(appsData.apps || []);
      setStats(statsData.stats);
    } catch (error) {
      console.error('Error loading system data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAppClick = (app) => {
    if (app.path && onNavigate) {
      onNavigate(app.path);
    }
  };

  if (loading) {
    return (
      <div className="system-page">
        <div className="system-container">
          <div className="loading-message">Loading System...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="system-page">
      <div className="system-container">
        <div className="system-header">
          <h1 className="system-title">⚙️ System</h1>
          <p className="system-subtitle">Centralized Control Center</p>
        </div>

        {stats && (
          <div className="system-stats">
            <div className="stat-card">
              <div className="stat-icon">👥</div>
              <div className="stat-value">{stats.users || 0}</div>
              <div className="stat-label">Users</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">📚</div>
              <div className="stat-value">{stats.wikiPages || 0}</div>
              <div className="stat-label">Wiki Pages</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">💬</div>
              <div className="stat-value">{stats.servers || 0}</div>
              <div className="stat-label">DropCord Servers</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">🎁</div>
              <div className="stat-value">{stats.activeGiveaways || 0}</div>
              <div className="stat-label">Active Giveaways</div>
            </div>
          </div>
        )}

        <div className="system-apps">
          <h2 className="apps-title">Available Applications</h2>
          <div className="apps-grid">
            {apps.map((app) => (
              <div
                key={app.id}
                className="app-card"
                onClick={() => handleAppClick(app)}
              >
                <div className="app-icon">{app.icon}</div>
                <div className="app-info">
                  <h3 className="app-name">{app.name}</h3>
                  <p className="app-description">{app.description}</p>
                </div>
                <div className="app-arrow">→</div>
              </div>
            ))}
          </div>
        </div>

        {apps.length === 0 && (
          <div className="no-apps-message">
            <p>No applications available at this time.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default System;
